export const dataHooks = {
    fadeStyles: 'fadeStyles',
    moveStyles: 'moveStyles',
    toggleStyles: 'toggleStyles',
    scaleStyles: 'scaleStyles',
    transition: 'transition',
};
export const easingMap = {
    standardEasing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
    enterEasing: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
    exitEasing: 'cubic-bezier(0.4, 0.0, 1, 1)',
};
export const timingMap = {
    short: 100,
    medium: 150,
    long: 200,
    fast01: 100,
    fast02: 150,
    medium01: 200,
    medium02: 300,
    slow01: 450,
    slow02: 600,
};
//# sourceMappingURL=constants.js.map